type Props = {
  before: string;
  after: string;
  beforeLabel: string;
  afterLabel: string;
  alt: string;
  /** Portrait phone frames sit side by side; landscape frames stack. */
  portrait?: boolean;
};

// Two real frames from the same timestamp: the source frame and the rendered output.
export default function FramePair({ before, after, beforeLabel, afterLabel, alt, portrait = false }: Props) {
  const frames: [string, string][] = [[before, beforeLabel], [after, afterLabel]];
  return (
    <div className={`grid gap-3 ${portrait ? 'grid-cols-2' : 'grid-cols-1'}`}>
      {frames.map(([src, label]) => (
        <figure key={label} className="relative overflow-hidden rounded-lg bg-gray-900">
          <img src={src} alt={`${alt}（${label}）`} loading="lazy" className={`w-full object-cover ${portrait ? 'aspect-[9/16]' : 'aspect-video'}`} />
          <figcaption className="absolute left-2 top-2 rounded bg-black/70 px-2 py-0.5 text-xs text-white">{label}</figcaption>
        </figure>
      ))}
    </div>
  );
}
